import axios from 'axios';
import { getAccessToken } from '../utils/token';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Attach the access token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    const appId = process.env.REACT_APP_APP_ID;

    // 🔁 Auto-detect if data is FormData
    const isFormData = config.data instanceof FormData;

    // ✅ Set correct Content-Type
    config.headers['Content-Type'] = isFormData
      ? 'multipart/form-data'
      : 'application/json';

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (appId) {
      config.headers['x-app-id'] = appId;
    }
    //console.log(config);
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
